import styled from "styled-components";

export const List = styled.ul`
  padding-top: 50px;
  width: 50%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;
